export const ROUTE_POINTS = [
  {
    id: 1,
    order: 1,
    slug: "okno-na-swiat",
    title: "Okno na świat",
    shortDescription: "Początek wyprawy przez dzieje Subków.",
    lat: 53.9855155,
    lng: 18.7592363,
  },
  {
    id: 2,
    order: 2,
    slug: "leonid-teliga",
    title: "Leonid Teliga",
    shortDescription: "Druga stacja szlaku prowadzi do opowieści o marzeniu...",
    lat: 53.985456,
    lng: 18.759088,
  },
  {
    id: 3,
    order: 3,
    slug: "sobek",
    title: "Sobek",
    shortDescription: "Sobek brzmi tajemniczo i intrygująco...",
    lat: 53.985638,
    lng: 18.758432,
  },
  {
    id: 4,
    order: 4,
    slug: "grod-kerin",
    title: "Gród Kerin",
    shortDescription: "Gród Kerin odwołuje się do świata dawnych osad...",
    lat: 53.985779,
    lng: 18.758373,
  },
  {
    id: 5,
    order: 5,
    slug: "rzym",
    title: "Rzym",
    shortDescription: "Rzym to skojarzenie z wielką cywilizacją...",
    lat: 53.985776,
    lng: 18.758077,
  },
  {
    id: 6,
    order: 6,
    slug: "slowianie-i-wikingowie",
    title: "Słowianie i Wikingowie",
    shortDescription: "Ten punkt przywołuje spotkanie dwóch światów...",
    lat: 53.985825,
    lng: 18.757888,
  },
  {
    id: 7,
    order: 7,
    slug: "sw-wojciech",
    title: "Św. Wojciech",
    shortDescription: "Św. Wojciech to punkt związany z pamięcią...",
    lat: 53.985533,
    lng: 18.757964,
  },
  {
    id: 8,
    order: 8,
    slug: "odwaga",
    title: "Odwaga",
    shortDescription: "Odwaga domyka trasę jako symbol działania...",
    lat: 53.985507,
    lng: 18.757692,
  },
];

export const ROUTE_START = ROUTE_POINTS[0];

export const ORDERED_ROUTE_NODES = ROUTE_POINTS;